{
  "close": "Закрыть"
}
